/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductAirConditioningList } from '../models/PaginatedProductAirConditioningList';
import type { PatchedProductAirConditioning } from '../models/PatchedProductAirConditioning';
import type { ProductAirConditioning } from '../models/ProductAirConditioning';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsAirConditioningService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductAirConditioningList
     * @throws ApiError
     */
    public productsAirConditioningList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductAirConditioningList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-air-conditioning/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductAirConditioning
     * @throws ApiError
     */
    public productsAirConditioningCreate({
        requestBody,
    }: {
        requestBody: ProductAirConditioning,
    }): CancelablePromise<ProductAirConditioning> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-air-conditioning/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductAirConditioning
     * @throws ApiError
     */
    public productsAirConditioningRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product air conditioning.
         */
        id: number,
    }): CancelablePromise<ProductAirConditioning> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-air-conditioning/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductAirConditioning
     * @throws ApiError
     */
    public productsAirConditioningUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product air conditioning.
         */
        id: number,
        requestBody: ProductAirConditioning,
    }): CancelablePromise<ProductAirConditioning> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-air-conditioning/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductAirConditioning
     * @throws ApiError
     */
    public productsAirConditioningPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product air conditioning.
         */
        id: number,
        requestBody?: PatchedProductAirConditioning,
    }): CancelablePromise<ProductAirConditioning> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-air-conditioning/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsAirConditioningDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product air conditioning.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-air-conditioning/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
